(function () {
  var ITEM = '.moonbundle-cart-item';
  var ABO_VARIANTES = ['59037891461452'];
  var SECTION = '.moonbundle-subscribe-save-section';
  var MUTATION = /\/cart\/(change|update)(\.js)?/;
  var ADD = /\/cart\/add(\.js)?/;
  var CART = /\/cart\/(change|update|add)(\.js)?/;
  var nativeFetch = window.fetch;
  var bundleKeys = null;
  var lastKeys = [];
  var lastItems = [];
  var busy = false;
  var again = false;
  var seq = 0;
  var cartCurrency = 'EUR';
  var chain = Promise.resolve();
  var timer = 0;
  var repairing = {};
  var attempts = {};

  function sameKey(a, b) {
    if (!a || !b) return false;
    a = String(a); b = String(b);
    if (a === b) return true;
    var fa = a.indexOf(':') !== -1, fb = b.indexOf(':') !== -1;
    if (fa && fb) return false;
    return a.split(':')[0] === b.split(':')[0];
  }

  function isBundleKey(key) {
    if (!bundleKeys) return true;
    for (var i = 0; i < bundleKeys.length; i++) if (sameKey(key, bundleKeys[i])) return true;
    return false;
  }

  var MONEY = /€\s?(\d{4,}(?:,\d{1,2})?|\d+\.\d{1,2}(?!\d)|\d{1,3}(?:[.   ]\d{3})*(?:,\d{1,2})?)/g;

  function frenchMoney(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) if (n.nodeValue && n.nodeValue.indexOf('€') !== -1) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) {
      var v = nodes[i].nodeValue;
      var next = v.replace(MONEY, '$1 €');
      if (next !== v) nodes[i].nodeValue = next;
    }
  }

  function isPackLine(it) {
    return !!(it && it.properties && it.properties.__moonbundle !== undefined);
  }

  function euros(cents) {
    var v = Math.round(cents) / 100;
    return (v % 1 ? v.toFixed(2) : String(v)).replace('.', ',') + ' €';
  }

  function packHeadline() {
    if (cartCurrency !== 'EUR') return '';
    var count = 0, paid = 0, full = 0;
    for (var i = 0; i < lastItems.length; i++) {
      var it = lastItems[i];
      if (!isPackLine(it)) continue;
      count += it.quantity || 0;
      paid += it.final_line_price || 0;
      full += it.original_line_price || 0;
    }
    if (!count) return '';
    var txt = 'Compose ton pack · ' + count + ' numéro' + (count > 1 ? 's' : '') + ' · ' + euros(paid);
    if (full > paid) txt += ' au lieu de ' + euros(full);
    return txt;
  }

  function setAttr(el, name, value) {
    if (value === null) { if (el.hasAttribute(name)) el.removeAttribute(name); }
    else if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function aboLibelle(it) {
    var o = aboOffre();
    var f = aboFormule(it, o && o.plans ? o : { plans: {} });
    if (!f) return '';
    if (f.indexOf('cadeau_') === 0) return 'Abonnement offert · ' + (/deux_ans$/.test(f) ? '2 ans' : '1 an');
    return /deux_ans$/.test(f) ? '2 ans · 8 numéros' : '1 an · 4 numéros';
  }

  function aujourdhuiParis() {
    var e = aboEmbarqueeDeLaPage();
    var t = e ? e.d.maintenant * 1000 + (Date.now() - e.recuLe) : Date.now();
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(t));
      var v = function (k) { for (var i = 0; i < parts.length; i++) if (parts[i].type === k) return parts[i].value; return ''; };
      return v('year') + '-' + v('month') + '-' + v('day');
    } catch (err) {
      return new Date(t).toISOString().slice(0, 10);
    }
  }

  function aboCadeauTexte(it) {
    var p = it.properties || {};
    var pour = String(p['Cadeau pour'] || '').trim();
    if (!pour) return '';
    var de = String(p['De la part de'] || '').trim();
    var lignes = ['Pour ' + pour + (de ? ' · de la part de ' + de : '')];
    if (String(p['E-mail du destinataire'] || '').trim()) {
      var quand = String(p['Lui annoncer le'] || '').trim();
      var date = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(quand);
      lignes.push('Annonce par e-mail ' + (date && date[3] + '-' + date[2] + '-' + date[1] > aujourdhuiParis() ? 'le ' + quand : 'juste après la commande'));
    }
    return lignes.join('\n');
  }

  function aboPremierTexte(it) {
    var p = it.properties || {};
    if (!p._premier_numero) return '';
    return 'Premier numéro : N°' + p._premier_numero +
      (p._premier_periode ? ' · parution ' + p._premier_periode : p._premier_envoi ? ' · envoi à partir de sa parution' : ' · avec le prochain envoi');
  }

  function cleAbonnement(key) {
    return ABO_VARIANTES.indexOf(String(key || '').split(':')[0]) !== -1;
  }

  function aboDeCle(key) {
    for (var i = 0; i < lastItems.length; i++) if (aboLigne(lastItems[i]) && sameKey(key, lastItems[i].key)) return lastItems[i];
    return null;
  }

  function marquerPanierAbonnement(present) {
    var racine = document.documentElement;
    if (racine && typeof racine.setAttribute === 'function') setAttr(racine, 'data-vw-panier-abo', present ? '1' : null);
  }

  function marquerAbonnements() {
    var items = document.querySelectorAll(ITEM + '[data-item-key]');
    var present = false;
    for (var i = 0; i < items.length; i++) {
      if (cleAbonnement(items[i].getAttribute('data-item-key'))) { setAttr(items[i], 'data-vw-abo-panier', '1'); present = true; }
    }
    marquerPanierAbonnement(present);
  }

  function mark() {
    frenchMoney(document.querySelector('.moonbundle-cart-drawer'));
    var items = document.querySelectorAll(ITEM + '[data-item-key]');
    var headline = packHeadline();
    var headDone = false;
    var aboPresent = false;
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var locked = isBundleKey(el.getAttribute('data-item-key'));
      var want = locked ? 'no' : 'ok';
      if (el.getAttribute('data-vw-sub') !== want) el.setAttribute('data-vw-sub', want);
      var fields = el.querySelectorAll(SECTION + ' input,' + SECTION + ' select,' + SECTION + ' button');
      for (var j = 0; j < fields.length; j++) {
        if (locked && !fields[j].disabled) fields[j].disabled = true;
        else if (!locked && fields[j].disabled && fields[j].getAttribute('data-vw-locked') === '1') fields[j].disabled = false;
        if (locked) fields[j].setAttribute('data-vw-locked', '1');
      }
      var pack = locked && bundleKeys !== null;
      setAttr(el, 'data-vw-pack-head', pack && headline && !headDone ? headline : null);
      if (pack && headline && !headDone) headDone = true;
      var title = el.querySelector('.moonbundle-cart-item-title');
      if (title) setAttr(title, 'data-vw-pack-tag', pack ? 'Compose ton pack' : null);
      var cle = el.getAttribute('data-item-key');
      var abo = aboDeCle(cle);
      setAttr(el, 'data-vw-abo-panier', abo || cleAbonnement(cle) ? '1' : null);
      if (abo || cleAbonnement(cle)) aboPresent = true;
      setAttr(el, 'data-vw-abo-offert', abo && aboCadeauTexte(abo) ? '1' : null);
      if (title) {
        var lignes = abo ? [aboLibelle(abo), aboCadeauTexte(abo), aboPremierTexte(abo)].filter(function (t) { return t; }).join('\n') : '';
        setAttr(title, 'data-vw-abo-texte', lignes || null);
      }
    }
    marquerPanierAbonnement(aboPresent);
  }

  function cartJson() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } });
  }

  function readCart() {
    var n = ++seq;
    return cartJson()
      .then(function (r) { if (!r || !r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) {
        var items = cart && cart.items;
        if (!Array.isArray(items)) throw new Error('cart');
        if (n !== seq) return items;
        cartCurrency = cart.currency || 'EUR';
        var keys = [];
        var order = [];
        for (var i = 0; i < items.length; i++) {
          order.push(items[i].key);
          if (items[i].properties && items[i].properties.__moonbundle) keys.push(items[i].key);
        }
        bundleKeys = keys;
        lastKeys = order;
        lastItems = items;
        mark();
        return items;
      });
  }

  function packAdd(texte) {
    var payload = readBody(texte);
    if (!payload) return false;
    var items = Array.isArray(payload.items) ? payload.items : [payload];
    for (var i = 0; i < items.length; i++) if (isPackLine(items[i])) return true;
    var keys = Object.keys(payload);
    for (var k = 0; k < keys.length; k++) if (keys[k].indexOf('__moonbundle') !== -1) return true;
    return false;
  }

  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function clearPack() {
    return readCart().then(function (items) {
      var updates = {};
      var old = [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!isPackLine(it)) continue;
        updates[it.key] = 0;
        old.push({ id: it.variant_id, quantity: it.quantity, properties: it.properties });
      }
      if (!old.length) return { ok: true, old: old };
      return nativeFetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { if (!r || !r.ok) throw new Error('update'); return r.json(); })
        .then(function () { return readCart(); })
        .then(function (after) {
          for (var j = 0; j < after.length; j++) {
            if (isPackLine(after[j]) && updates.hasOwnProperty(after[j].key)) return { ok: false, old: old };
          }
          return { ok: true, old: old };
        })
        .catch(function () { return { ok: false, old: old }; });
    }).catch(function () { return { ok: false, old: [] }; });
  }

  function restorePack(old) {
    if (!old || !old.length) return Promise.resolve();
    return nativeFetch('/cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: old }) })
      .catch(function () {})
      .then(function () { schedule(); });
  }

  function errorJson(status, message) {
    var body = JSON.stringify({ status: status, message: message, description: message });
    try {
      return Promise.resolve(new Response(body, { status: status, headers: { 'Content-Type': 'application/json' } }));
    } catch (e) { return denied(); }
  }

  function serial(fn) {
    var p = chain.then(fn, fn);
    chain = p.then(function () {}, function () {});
    return p;
  }

  var LOCK = 'vw-pack-lock';
  function lock() {
    var start = Date.now();
    return new Promise(function (resolve) {
      (function attempt() {
        var held = 0;
        try { held = parseInt(localStorage.getItem(LOCK), 10) || 0; } catch (e) {}
        if (held && Date.now() - held < 15000 && Date.now() - start < 5000) return setTimeout(attempt, 100);
        try { localStorage.setItem(LOCK, String(Date.now())); } catch (e) {}
        resolve(function () { try { localStorage.removeItem(LOCK); } catch (e) {} });
      })();
    });
  }

  function replacePack(pass) {
    return lock().then(function (release) {
      return clearPack().then(function (res) {
        if (!res.ok) return errorJson(422, 'Le panier n’a pas pu être mis à jour, réessayez dans un instant.');
        return pass().then(function (r) {
          if (r && r.status >= 400 && r.status < 500) return restorePack(res.old).then(function () { return r; });
          return r;
        }, function (e) {
          return readCart().then(function (items) {
            for (var i = 0; i < items.length; i++) if (isPackLine(items[i])) return null;
            return restorePack(res.old);
          }, function () {}).then(function () { throw e; });
        });
      }).then(function (r) { release(); return r; }, function (e) { release(); throw e; });
    });
  }

  function repair(items) {
    var bad = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.properties && it.properties.__moonbundle && it.selling_plan_allocation && !repairing[it.key] && (attempts[it.key] || 0) < 3) bad.push(it);
    }
    if (!bad.length) return Promise.resolve(false);
    var fixed = false;
    var seq = Promise.resolve();
    bad.forEach(function (it) {
      repairing[it.key] = 1;
      attempts[it.key] = (attempts[it.key] || 0) + 1;
      seq = seq.then(function () {
        return nativeFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: it.quantity, selling_plan: null })
        }).then(function (r) { if (r && r.ok) fixed = true; }).catch(function () {}).then(function () { delete repairing[it.key]; });
      });
    });
    return seq.then(function () { return fixed; });
  }

  var ABO_SKU = 'ABO-VIEWS-MAGAZINE';
  var ABO_HANDLE = 'abonnement';
  var ABO_FORMULES = ['un_an', 'deux_ans', 'cadeau_un_an', 'cadeau_deux_ans'];
  var ABO_MESSAGES = {
    seconde: 'Une seule formule par commande. Pour offrir un abonnement en plus du vôtre, passez une seconde commande.',
    quantite: 'Un abonnement se prend à l’unité : la quantité est revenue à 1.',
    ferme: 'Les abonnements sont provisoirement fermés : nous avons retiré l’abonnement de votre panier. Ils rouvriront bientôt.',
    formule: 'Cette formule n’est plus proposée : nous l’avons retirée de votre panier. Choisissez à nouveau votre formule sur la page Abonnement.',
    modalites: 'Les modalités de votre abonnement ont été mises à jour depuis votre ajout au panier : nous l’avons retiré de votre panier. Ajoutez-le à nouveau depuis la page Abonnement.',
    echec: 'Votre panier n’a pas pu être vérifié. Rechargez la page pour continuer.',
    mixte: 'Votre panier contient un abonnement et d’autres articles. L’abonnement se commande seul : retirez l’un ou l’autre pour continuer.',
    patience: 'Votre panier se met à jour. Cliquez à nouveau sur le paiement dans un instant.'
  };
  var ABO_MEMO = 'vw-abo-garde';
  var ABO_TOURS = 6;
  var ABO_GESTES_MAX = 12;
  var aboEmbarquee = null;
  var aboEnCours = false;
  var aboGestes = 0;
  var aboBloque = false;
  var aboEchecDit = false;
  var aboMixteDit = false;
  var aboEnVol = 0;
  var aboLu = false;
  var aboPatienceDepuis = 0;
  var aboMinuteur = 0;
  var aboExpiration = 0;

  function aboLireEmbarquee(texte, recuLe) {
    var d = null;
    try { d = JSON.parse(texte || ''); } catch (e) { return null; }
    if (!d || typeof d.maintenant !== 'number') return null;
    return { d: d, recuLe: recuLe };
  }

  function aboEmbarqueeDeLaPage() {
    if (aboEmbarquee) return aboEmbarquee;
    var el = document.getElementById('vw-abonnement-offre');
    aboEmbarquee = el ? aboLireEmbarquee(el.textContent, Date.now()) : null;
    return aboEmbarquee;
  }

  function aboOffre() {
    var e = aboEmbarqueeDeLaPage();
    if (!e || e.d.verdict !== 'ouverte' || !e.d.offre) return null;
    var o = e.d.offre;
    var maintenant = e.d.maintenant * 1000 + (Date.now() - e.recuLe);
    var ecrit = Date.parse(o.ecrit_le);
    var valide = Date.parse(o.valide_jusqu_a);
    if (!(ecrit > 0) || !(valide > 0)) return null;
    var fin = Math.min(valide, ecrit + 21600000);
    if (maintenant >= fin) return { perimee: true };
    if ((o.etat !== 'epuise' && o.etat !== 'en_stock') || !o.premier || o.offre === undefined || o.offre === null) return null;
    var finRecette = o.recette_cadeau_jusqu_a ? Date.parse(o.recette_cadeau_jusqu_a) : NaN;
    var plans = {};
    for (var i = 0; i < ABO_FORMULES.length; i++) {
      var f = ABO_FORMULES[i];
      var id = o.plans && o.plans[f] ? String(o.plans[f]) : '';
      if (id && f.indexOf('cadeau_') === 0 && o.recette_cadeau_jusqu_a && !(maintenant < finRecette)) id = '';
      if (id) plans[f] = id;
    }
    if (!plans.un_an && !plans.deux_ans) return null;
    var reste = fin - maintenant;
    if (o.recette_cadeau_jusqu_a && finRecette > maintenant) reste = Math.min(reste, finRecette - maintenant);
    return {
      plans: plans,
      reste: reste,
      attendu: {
        _premier_numero: String(o.premier),
        _parution: String(o.parution_affichee || ''),
        _premier_envoi: String(o.premier_envoi_affiche || ''),
        _premier_periode: aboPremierePeriode(o),
        _abo_offre: String(o.offre)
      }
    };
  }

  function aboRafraichirOffre() {
    return nativeFetch('/cart', { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r || !r.ok) throw new Error('page'); return r.text(); })
      .then(function (html) {
        var m = /<script type="application\/json" id="vw-abonnement-offre">([\s\S]*?)<\/script>/.exec(String(html || ''));
        var e = m ? aboLireEmbarquee(m[1], Date.now()) : null;
        if (e) aboEmbarquee = e;
      })
      .catch(function () {});
  }

  function aboLigne(it) {
    return !!it && (String(it.sku || '') === ABO_SKU || String(it.handle || '') === ABO_HANDLE);
  }

  function aboPlan(it) {
    var a = it && it.selling_plan_allocation;
    return a && a.selling_plan && a.selling_plan.id !== undefined && a.selling_plan.id !== null ? String(a.selling_plan.id) : '';
  }

  function aboFormule(it, offre) {
    var plan = aboPlan(it);
    for (var i = 0; i < ABO_FORMULES.length; i++) if (plan && offre.plans[ABO_FORMULES[i]] === plan) return ABO_FORMULES[i];
    var a = it.selling_plan_allocation;
    var nom = String((a && a.selling_plan && a.selling_plan.name) || '');
    var deux = /(^|[^0-9])2 ans\b/.test(nom);
    var un = /(^|[^0-9])1 an\b/.test(nom);
    if (deux === un) return null;
    return (/cadeau/i.test(nom) ? 'cadeau_' : '') + (deux ? 'deux_ans' : 'un_an');
  }

  function aboPremierePeriode(o) {
    if (o.etat !== 'epuise' || !o.premier_envoi_affiche || !o.parution_periode) return '';
    return String(o.parution_periode);
  }

  function aboValeur(v) {
    return v === undefined || v === null ? '' : String(v);
  }

  function aboGeste(items) {
    var offre = null;
    var vues = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!aboLigne(it)) continue;
      vues++;
      var cle = it.key;
      if (vues === 1) offre = aboOffre();
      if (!offre || offre.perimee) return { corps: { id: cle, quantity: 0 }, messages: [ABO_MESSAGES.ferme] };
      if (vues > 1) return { corps: { id: cle, quantity: 0 }, messages: [ABO_MESSAGES.seconde] };
      var formule = aboFormule(it, offre);
      var plan = formule ? offre.plans[formule] : '';
      if (!plan) return { corps: { id: cle, quantity: 0 }, messages: [ABO_MESSAGES.formule] };
      if (aboPlan(it) !== plan) return { corps: { id: cle, quantity: 0 }, messages: [ABO_MESSAGES.modalites] };
      var props = {};
      var source = it.properties || {};
      for (var k in source) {
        if (Object.prototype.hasOwnProperty.call(source, k) && source[k] !== null && source[k] !== undefined) props[k] = source[k];
      }
      var change = false;
      var annonce = false;
      for (var a in offre.attendu) {
        if (aboValeur(props[a]) !== offre.attendu[a]) {
          change = true;
          if (a === '_premier_numero' || a === '_premier_envoi' || a === '_premier_periode') annonce = true;
        }
        props[a] = offre.attendu[a];
      }
      var corps = { id: cle, quantity: 1, properties: props };
      var messages = [];
      if (annonce) {
        messages.push('Le premier numéro de votre abonnement a été mis à jour : N°' + offre.attendu._premier_numero +
          (offre.attendu._premier_periode ? ', qui paraîtra ' + offre.attendu._premier_periode
            : offre.attendu._premier_envoi ? ', envoyé à partir de sa parution' : ', avec le prochain envoi') + '.');
      }
      if (it.quantity !== 1) { change = true; messages.push(ABO_MESSAGES.quantite); }
      if (change) return { corps: corps, messages: messages };
    }
    return null;
  }

  function aboContient(items) {
    for (var i = 0; i < items.length; i++) if (aboLigne(items[i])) return true;
    return false;
  }

  function aboMixte(items) {
    var abo = false;
    var autre = false;
    for (var i = 0; i < items.length; i++) {
      if (aboLigne(items[i])) abo = true;
      else autre = true;
    }
    return abo && autre;
  }

  function aboMarquerMixte(mixte) {
    var bandeaux = document.querySelectorAll('[data-vw-abo-mixte]');
    for (var i = 0; i < bandeaux.length; i++) bandeaux[i].hidden = !mixte;
    var express = document.querySelectorAll('[data-vw-abo-express]');
    for (var j = 0; j < express.length; j++) express[j].hidden = mixte;
  }

  function aboDire(liste) {
    if (!liste.length || !document.body) return;
    var el = document.getElementById('vw-abo-garde');
    if (!el) {
      el = document.createElement('p');
      el.id = 'vw-abo-garde';
      el.className = 'vw-abo-garde';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.addEventListener('click', function () { el.hidden = true; });
      document.body.appendChild(el);
    }
    el.textContent = liste.join(' ');
    el.hidden = false;
    window.clearTimeout(aboMinuteur);
    aboMinuteur = window.setTimeout(function () { el.hidden = true; }, 12000);
  }

  function aboSurPanier() {
    return /^\/cart\/?$/.test(window.location.pathname || '');
  }

  function aboApresGestes(messages) {
    try { window.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
    if (aboSurPanier()) {
      var rechargements = 0;
      try { rechargements = parseInt(sessionStorage.getItem(ABO_MEMO + '-n'), 10) || 0; } catch (e) {}
      if (rechargements < 3) {
        try {
          sessionStorage.setItem(ABO_MEMO, JSON.stringify(messages));
          sessionStorage.setItem(ABO_MEMO + '-n', String(rechargements + 1));
        } catch (e) {}
        window.location.reload();
        return;
      }
    }
    aboDire(messages);
  }

  function aboEchec() {
    aboBloque = true;
    if (!aboEchecDit) { aboEchecDit = true; aboDire([ABO_MESSAGES.echec]); }
  }

  function aboArmerExpiration(items) {
    window.clearTimeout(aboExpiration);
    if (!aboContient(items)) return;
    var offre = aboOffre();
    if (offre && !offre.perimee && offre.reste > 0) {
      aboExpiration = window.setTimeout(schedule, Math.min(offre.reste + 1000, 2147483000));
    }
  }

  function aboGarder(items) {
    if (aboEnCours) return Promise.resolve(false);
    if (!aboContient(items)) {
      aboBloque = false;
      aboMixteDit = false;
      aboMarquerMixte(false);
      try { sessionStorage.removeItem(ABO_MEMO + '-n'); } catch (e) {}
      return Promise.resolve(false);
    }
    aboEnCours = true;
    var fait = false;
    var dits = [];
    var preparation = Promise.resolve();
    var offre = aboOffre();
    if (offre && offre.perimee) preparation = aboRafraichirOffre();
    function lire() {
      return cartJson().then(function (r) {
        if (!r || !r.ok) throw new Error('cart');
        return r.json();
      }).then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) throw new Error('cart');
        return cart.items;
      });
    }
    function tour(n) {
      return lire().then(function (courants) {
        var g = aboGeste(courants);
        if (!g) return { items: courants, conforme: true };
        if (n >= ABO_TOURS || aboGestes >= ABO_GESTES_MAX) return { items: courants, conforme: false };
        aboGestes++;
        return nativeFetch('/cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(g.corps) })
          .then(function (r) {
            if (r && r.ok) {
              fait = true;
              for (var m = 0; m < g.messages.length; m++) if (dits.indexOf(g.messages[m]) === -1) dits.push(g.messages[m]);
            }
          }, function () {})
          .then(function () { return tour(n + 1); });
      });
    }
    return preparation
      .then(function () { return tour(0); })
      .then(function (fin) { return fin; }, function () { return { items: items, conforme: false }; })
      .then(function (fin) {
        aboEnCours = false;
        aboBloque = !fin.conforme;
        if (fin.conforme) {
          aboEchecDit = false;
          aboArmerExpiration(fin.items);
          if (!fait) try { sessionStorage.removeItem(ABO_MEMO + '-n'); } catch (e) {}
        }
        if (!fin.conforme && dits.indexOf(ABO_MESSAGES.echec) === -1) { dits.push(ABO_MESSAGES.echec); aboEchecDit = true; }
        lastItems = fin.items;
        var mixte = aboMixte(fin.items);
        aboMarquerMixte(mixte);
        if (!mixte) aboMixteDit = false;
        else if (fin.conforme && !aboMixteDit) { aboMixteDit = true; dits.push(ABO_MESSAGES.mixte); }
        if (fait) aboApresGestes(dits);
        else if (dits.length) aboDire(dits);
        return fait;
      });
  }

  function aboMemoire() {
    var liste = null;
    try {
      liste = JSON.parse(sessionStorage.getItem(ABO_MEMO) || 'null');
      sessionStorage.removeItem(ABO_MEMO);
    } catch (e) {}
    if (Array.isArray(liste)) aboDire(liste);
  }

  function aboPanierDouteux() {
    if (aboEnCours || aboBloque) return true;
    if (!aboContient(lastItems)) return !!document.querySelector('[data-vw-abo-ligne]') && bundleKeys === null;
    return aboGeste(lastItems) !== null || aboMixte(lastItems);
  }

  function aboCible(cible) {
    return cible && cible.closest ? cible.closest('[name="checkout"], a[href*="/checkout"], [data-vw-checkout], .moonbundle-cart-drawer-checkout') : null;
  }

  function aboVersPaiement(cible) {
    return !!aboCible(cible);
  }

  function aboStopper(e) {
    try { e.preventDefault(); } catch (x) {}
    try { e.stopImmediatePropagation(); } catch (x) {}
    try { e.stopPropagation(); } catch (x) {}
  }

  function aboArreter(e) {
    aboStopper(e);
    var message = aboBloque ? ABO_MESSAGES.echec : aboMixte(lastItems) ? ABO_MESSAGES.mixte : ABO_MESSAGES.patience;
    if (message === ABO_MESSAGES.patience && !aboPatienceDepuis) aboPatienceDepuis = Date.now();
    aboDire([message]);
    schedule();
  }

  function aboMutation() {
    var finie = false;
    aboEnVol++;
    aboLu = false;
    function fin() {
      if (finie) return;
      finie = true;
      if (aboEnVol > 0) aboEnVol--;
      aboLu = false;
      schedule();
    }
    window.setTimeout(fin, 10000);
    return fin;
  }

  function aboRelire() {
    aboLu = false;
    schedule();
  }

  function aboIncertain() {
    return aboEnVol > 0 || aboLu !== true;
  }

  function aboTrace() {
    return aboContient(lastItems) || (bundleKeys === null && !!document.querySelector('[data-vw-abo-ligne]'));
  }

  function aboAuPaiement(e) {
    if (!aboTrace()) return;
    if (aboIncertain() || aboEnCours) {
      var maintenant = Date.now();
      if (!aboPatienceDepuis) aboPatienceDepuis = maintenant;
      if (maintenant - aboPatienceDepuis > 8000) return;
      aboStopper(e);
      aboDire([ABO_MESSAGES.patience]);
      if (aboLu !== null) schedule();
      return;
    }
    if (aboPanierDouteux()) aboArreter(e);
    else aboPatienceDepuis = 0;
  }

  document.addEventListener('click', function (e) {
    if (aboVersPaiement(e.target)) aboAuPaiement(e);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form && form.getAttribute ? String(form.getAttribute('action') || '') : '';
    var versPaiement = /\/checkout(\/|\?|$)/.test(action) || (/\/cart(\/|\?|$)/.test(action) && !!(e.submitter && e.submitter.getAttribute && e.submitter.getAttribute('name') === 'checkout'));
    if (versPaiement) aboAuPaiement(e);
  }, true);

  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    again = false;
    aboLu = null;
    readCart()
      .then(function (items) {
        if (items === lastItems) {
          try { document.dispatchEvent(new CustomEvent('vw:cart', { detail: { items: items } })); } catch (e) {}
        }
        return repair(items).then(function (did) {
          return aboGarder(items).then(function (garde) { return did || garde; });
        });
      }, function () {
        if (aboContient(lastItems) || document.querySelector('[data-vw-abo-ligne]')) aboEchec();
        return false;
      })
      .catch(function () { return false; })
      .then(function (did) {
        busy = false;
        if (did) window.setTimeout(refresh, 1000);
        else if (again) refresh();
        else if (aboEnVol > 0) return;
        else if (aboLu === null) { aboLu = true; aboPatienceDepuis = 0; }
        else refresh();
      });
  }

  function schedule() {
    if (timer) return;
    timer = window.setTimeout(function () { timer = 0; refresh(); }, 150);
  }

  function touches(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches && node.matches(ITEM)) return true;
    if (node.parentElement && node.parentElement.closest && node.parentElement.closest(ITEM)) return true;
    return !!(node.querySelector && node.querySelector(ITEM));
  }

  function retire(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(ITEM)) return true;
    return !!(node.querySelector && node.querySelector(ITEM));
  }

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes || [];
      for (var j = 0; j < added.length; j++) if (touches(added[j])) { marquerAbonnements(); schedule(); return; }
      var removed = records[i].removedNodes || [];
      for (var k = 0; k < removed.length; k++) if (retire(removed[k])) { marquerAbonnements(); schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.moonbundle-cart-drawer, ' + ITEM)) schedule();
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.moonbundle-cart-drawer, ' + ITEM)) schedule();
  }, true);

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    try { return String(input); } catch (e) { return ''; }
  }

  function decode(buf) {
    try { if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(buf); } catch (e) {}
    return null;
  }

  function bodyText(body) {
    if (body === undefined || body === null) return '';
    if (typeof body === 'string') return body;
    try {
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.toString();
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var pairs = [];
        body.forEach(function (v, k) { pairs.push(encodeURIComponent(k) + '=' + encodeURIComponent(String(v))); });
        return pairs.join('&');
      }
      if (typeof ArrayBuffer !== 'undefined' && (body instanceof ArrayBuffer || ArrayBuffer.isView(body))) return decode(body);
    } catch (e) {}
    return null;
  }

  function bodyTextAsync(body) {
    try {
      if (typeof Blob !== 'undefined' && body instanceof Blob && typeof body.text === 'function') {
        return body.text().then(function (t) { return typeof t === 'string' ? t : null; }, function () { return null; });
      }
    } catch (e) {}
    return Promise.resolve(bodyText(body));
  }

  function requestText(input, init) {
    if (init && init.body !== undefined && init.body !== null) return bodyTextAsync(init.body);
    if (input && typeof input === 'object' && typeof input.clone === 'function') {
      try {
        var ct = '';
        try { ct = String((input.headers && input.headers.get('content-type')) || ''); } catch (e) {}
        if (/multipart\/form-data/i.test(ct) && typeof input.formData === 'function') {
          return input.clone().formData().then(function (fd) { return bodyText(fd); }, function () { return null; });
        }
        return input.clone().text().then(function (t) { return typeof t === 'string' ? t : null; }, function () { return null; });
      } catch (e) { return Promise.resolve(null); }
    }
    return Promise.resolve('');
  }

  function readBody(texte) {
    var t = String(texte || '').trim();
    if (!t) return null;
    if (t.charAt(0) === '{' || t.charAt(0) === '[') {
      try { return JSON.parse(t); } catch (e) { return null; }
    }
    try {
      var p = new URLSearchParams(t);
      var o = {};
      var vide = true;
      p.forEach(function (v, k) { o[k] = v; vide = false; });
      return vide ? null : o;
    } catch (e) { return null; }
  }

  function verdict(payload, keys, order) {
    var plan = payload && payload.selling_plan;
    if (plan === undefined || plan === null || plan === '' || plan === 'null') return false;
    if (keys === null) return null;
    var key = null;
    if (payload.id !== undefined && payload.id !== null) key = String(payload.id);
    else if (payload.line !== undefined) key = order[parseInt(payload.line, 10) - 1] || null;
    if (!key) return true;
    var i;
    for (i = 0; i < keys.length; i++) if (sameKey(key, keys[i])) return true;
    for (i = 0; i < order.length; i++) if (sameKey(key, order[i])) return false;
    return null;
  }

  function judge(texte) {
    if (texte === null) return true;
    var payload = readBody(texte);
    if (!payload) return texte.indexOf('selling_plan') !== -1;
    return verdict(payload, bundleKeys, lastKeys);
  }

  function hasPlan(v) {
    return v !== undefined && v !== null && v !== '' && v !== 'null';
  }

  function forgedAdd(texte) {
    if (texte === null || texte === '') return false;
    var payload = readBody(texte);
    if (!payload) return texte.indexOf('__moonbundle') !== -1 && texte.indexOf('selling_plan') !== -1;
    var items = Array.isArray(payload.items) ? payload.items : [payload];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it && hasPlan(it.selling_plan) && it.properties && typeof it.properties === 'object' && it.properties.__moonbundle !== undefined) return true;
    }
    var keys = Object.keys(payload);
    var bundle = false, plan = false;
    for (var k = 0; k < keys.length; k++) {
      if (keys[k].indexOf('__moonbundle') !== -1) bundle = true;
      if (/selling_plan/.test(keys[k]) && hasPlan(payload[keys[k]])) plan = true;
    }
    return bundle && plan;
  }

  function denied() {
    schedule();
    return cartJson();
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = '';
      var method = 'GET';
      try {
        url = urlOf(input);
        method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      } catch (e) {}
      if (method !== 'POST' || !CART.test(url)) return nativeFetch.apply(this, arguments);
      var self = this;
      var args = arguments;
      function pass() {
        var out = nativeFetch.apply(self, args);
        try { out.then(function () { schedule(); }, function () {}); } catch (e) {}
        return out;
      }
      var fin = aboMutation();
      function suivre(p) {
        try { p.then(fin, fin); } catch (e) { fin(); }
        return p;
      }
      if (ADD.test(url)) {
        return suivre(requestText(input, init).then(function (texte) {
          if (forgedAdd(texte)) return denied();
          if (packAdd(texte)) return serial(function () { return replacePack(pass); });
          return pass();
        }, function () { return pass(); }));
      }
      return suivre(requestText(input, init).then(function (texte) {
        if (texte === '') return nativeFetch.apply(self, args);
        if (texte === null) return denied();
        if (judge(texte) === false) return pass();
        return readCart().then(function () {
          return judge(texte) === false ? pass() : denied();
        }, function () { return denied(); });
      }, function () { return denied(); }));
    };
  }

  var xhrProto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (xhrProto && typeof xhrProto.open === 'function' && typeof xhrProto.send === 'function') {
    var nativeOpen = xhrProto.open;
    var nativeSend = xhrProto.send;
    xhrProto.open = function (method, url) {
      try {
        var u = String(url);
        this.__vwCart = CART.test(u);
        this.__vwMutation = String(method).toUpperCase() === 'POST' && MUTATION.test(u);
        this.__vwAdd = String(method).toUpperCase() === 'POST' && ADD.test(u);
      } catch (e) {}
      return nativeOpen.apply(this, arguments);
    };
    xhrProto.send = function (body) {
      var stop = false;
      var fin = null;
      try {
        if (this.__vwMutation || this.__vwAdd) {
          fin = aboMutation();
          this.addEventListener('loadend', fin);
        }
      } catch (e) {}
      try {
        if (this.__vwMutation) {
          var texte = bodyText(body);
          stop = texte !== '' && judge(texte) !== false;
        } else if (this.__vwAdd) {
          var t = bodyText(body);
          stop = forgedAdd(t);
          if (!stop && packAdd(t)) {
            var xhr = this;
            var args = arguments;
            serial(function () { return clearPack(); }).then(function () { nativeSend.apply(xhr, args); }, function () { nativeSend.apply(xhr, args); });
            return;
          }
        }
      } catch (e) { stop = true; }
      if (stop) {
        schedule();
        try {
          nativeOpen.call(this, 'GET', '/cart.js', true);
          return nativeSend.call(this);
        } catch (e) {}
        if (fin) fin();
        return;
      }
      try { if (this.__vwCart) this.addEventListener('load', function () { schedule(); }); } catch (e) {}
      return nativeSend.apply(this, arguments);
    };
  }

  window.addEventListener('focus', aboRelire);
  window.addEventListener('pageshow', aboRelire);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) aboRelire(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aboMemoire);
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    aboMemoire();
    schedule();
  }
})();
